import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const PaintSwatches = createSvgIcon(
  <path d="M10.5 0H0v24h10.5v-.69L23.979 8.507l-5.87-4.824.24-.61L10.5.328V0ZM2.25 18.75h6v3h-6v-3Zm6-2.25h-6v-6h6v6Zm-6-8.25v-6h6v6h-6Zm8.25 8.675V2.71l4.901 1.715-4.901 12.5Zm2.149.684 4.597-11.723 3.475 2.857-8.072 8.866Z" />,
  'PaintSwatches'
);

export { PaintSwatches };